import * as React from 'react'
// styles
import './styles.css'
// components
import SpotlightCarousel from './components/SpotlightCarousel'

const SpotlightComponent = () => {
  return (
    <section className='spotlight-section'>
      <div className='box'>
        <div className='spotlight-content'>
          <h2 className='spotlight-section-title'>Spotlight</h2>
          <SpotlightCarousel />
        </div>
      </div>
    </section>
  )
}

export default SpotlightComponent
